<template>
  <div class="house-importer-import-charges-stage-check-charges-panel" ref="container">
    <app-panel :title="panelTitle">

      <div slot="actions">
        <app-button color="success" @click="getData">Проверить</app-button>
      </div>

      <div v-if="status === STATUSES.loaded">
        <vs-table :data="charges" hoverFlat pagination max-items="48"
                  class="house-importer-import-charges-stage-check-charges-panel-collapse-item__table"
                  no-data-text="Данных нет">
          <template slot="thead">
            <vs-th>Аккаунт</vs-th>
            <vs-th>Начислено в ELSA</vs-th>
            <vs-th>Начислено в Квартале</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
              <vs-td>{{tr.account_number}}</vs-td>
              <vs-td>{{tr.elsa_charge_sum | numberWithSpaces}}</vs-td>
              <vs-td>{{tr.kvartal_charge_sum | numberWithSpaces}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

      </div>
      <div class="house-importer-import-charges-stage-check-charges-panel__error-block"
           v-if="status === STATUSES.error">
        {{textError}}
      </div>
      <div class="house-importer-import-charges-stage-check-charges-panel__loading-block"
           v-if="status === STATUSES.loading">
        <div class="block-loading"/>
        <div>Получаю данные...</div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  const STATUSES = {
    mounted: 0,
    loading: 1,
    loaded: 2,
    error: 5,
  };

  export default {
    name: "CheckTotalCharges",
    props: {
      importInfo: {}
    },
    data() {
      return {
        STATUSES: STATUSES,
        status: STATUSES.mounted,
        textError: "",
        charges: []
      }
    },
    computed: {
      panelTitle(){
        let subTitle = "";
        if( this.status === STATUSES.loaded){
          let chargesCount = this.charges.length || 0;
          subTitle = `<span style="color: rgba(var(--app-${chargesCount ? 'danger' : 'success'}), 1)">&nbsp;(${chargesCount})</span>`;
        }
        return `Проверка общей суммы начислений${subTitle}`;
      }
    },
    methods: {
      async getData() {
        this.status = STATUSES.loading;
        try {
          let {data} = await this.$http.get('import/houses/check_total_sums', {params: {import_id: this.importInfo.id}});
          this.charges = data;
          setTimeout(() => {
            this.status = STATUSES.loaded;
          }, 300);
        } catch (e) {
          if (e.response) {
            if (e.response.status === 404) {
              this.status = STATUSES.error;
              this.textError = "Заполните параметры начислений";
            }
          } else {
            this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
            this.status = STATUSES.mounted;
          }

        }
      },
    },
  }
</script>

<style lang="scss">
  .house-importer-import-charges-stage-check-charges-panel {
    &__loading-block {
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 20px;
      }
    }

    &__error-block {
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-weight: 500;
      text-align: center;
      font-size: 18px;
    }
  }

  .house-importer-import-charges-stage-check-charges-panel-collapse-item {
    .vs-collapse-item--header {
      padding: 15px 5px;
      font-size: 18px;
    }

    &.vs-collapse-item {
      border-bottom: 1px solid rgba(0, 0, 0, .2);
    }

    &.open-item .con-content--item {
      padding: 5px 5px 15px !important;
    }

    &__header {
      display: flex;
      align-items: center;

      &-text {
        font-size: 18px;
        line-height: 1.1;
        text-transform: capitalize;
      }
    }

    &__table {
      .vs-table--tbody {
        border: none;
        background: #fff;
      }

      .vs-table--thead th {
        padding: 0 !important;
        border-bottom: 1px solid rgba(0, 0, 0, .125);

        .vs-table-text {
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table {
        .vs-table--tr:nth-child(2n+1) {
          background: #f5f8fa;
        }
      }

      .tr-values td {
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }

    &__no-data {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 16px;
    }
  }
</style>